import React from 'react';
import { CtaButton } from './CtaButton';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8 md:py-20" data-id="element-199" data-mp="2lm0wbgl8jiwo">
      <div className="mx-auto max-w-3xl text-center" data-id="element-200" data-mp="26z7o0va4vddz">
        <h2 className="font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-201" data-mp="26wbox3mjuiny">
          👉 Do any of these sound familiar?
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-clay sm:text-lg" data-id="element-202" data-mp="1xwomqflzx8tu">
          If you answer <span className="font-bold text-ink" data-id="element-203" data-mp="21zl98henpp32">yes</span> to any of them, this
          system was created for you.
        </p>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-204" data-mp="1o1eirmc1erdf">
        {painPoints.map(point => <li key={point.text} className="flex h-full gap-4 rounded-2xl bg-cream p-5" data-id="element-205" data-mp="1t0r94h24agkr">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-206" data-mp="3ncfp8mk34p6q">
              {point.icon}
            </span>
            <p className="text-[15px] leading-snug text-ink/85" data-id="element-207" data-mp="1yzvhzf80mjsv">{point.text}</p>
          </li>)}
      </ul>

      <div className="mx-auto mt-12 max-w-2xl rounded-3xl border border-gold/40 bg-cream px-5 py-8 text-center sm:px-8" data-id="element-208" data-mp="1u0iyn4gcruv1">
        <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-209" data-mp="27s76uwnhdz6q">
          And you may not need more information
        </p>
        <p className="mt-4 font-display text-[22px] font-bold leading-snug text-ink sm:text-3xl" data-id="element-210" data-mp="1g1aury98vyki">
          You may simply need a better system for organizing the information you already have.
        </p>
        <p className="mt-5 text-[15px] leading-relaxed text-clay" data-id="element-211" data-mp="1p2r5k73z22p9">
          Resin Architect™ isn’t another endless course. It’s a visual decision and planning
          system built to organize the key variables of anterior composite cases.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-212" data-mp="30jh18warrc4m">
        <CtaButton label="I want a structured system" data-id="element-213" data-mp="2vhjg1wit6791" />
      </div>
    </section>;
}